export enum AuthType {
  Student,
  Person,
  Enterprise,
  FoxInvoiceInfo,
}
